<template>
    <div class="container-fluid mt-2" style="font-family:'Courier New'">
      <div class="text-center">
        <span v-if="userData.logo!=0"><img :src="getFiles(userData.logo)" height="40"/></span>
        <span v-else><img src="@/assets/images/logo.png" height="40"/></span><br>
        <h4 style="color:black" class="text-uppercase">{{ userData.business }}</h4>
        <span style="color:black;font-size:13px">Location : {{ userData.location }}</span><br>
        <span style="color:black;font-size:13px">Telephone : {{ userData.contact }}</span><br><br>
        <span style="color: black;font-size:13px" class="text-decoration-underline"><b> PAYMENT`s LEDGER</b></span><br>
        <span style="color:black;font-size:13px"> Visit ID : {{ this.visitid }}</span><br>
    </div>
      <table v-for="item in patients" :key="item.id" class="table">
      <tr><td> Full Name </td><td> <b class=" h7">{{ item.name }} </b></td></tr>
      <tr><td> Patient ID </td><td> <b class=" h7">{{ item.patient_id }} </b></td></tr>
      <tr><td> Gender </td><td> <span class=" h7">{{ item.gender }} </span></td></tr>
      <tr><td> Telephone </td><td> <span class=" h7">0{{ item.telephone }} </span></td></tr>
      <tr><td> Address </td><td> <span class=" h7">{{ item.address }} </span></td></tr>
      </table>

    <span v-if="services.length">
    <h5 >Services</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Category</th><th>Service Name</th><th>Price</th></tr></thead>
      <tbody>
        <tr v-for="item in services" :key="item.id">
            <td>{{ item.service_category.name }} </td>
            <td>{{ item.service_name.name }}</td>
            <td>{{ item.service_price }}</td>
        </tr>
      </tbody>
      </table>
      </span>
      <span v-if="prescriptions.length">
          <h5 >Presciptions</h5>
            <table class="table table-sm mt-n2" style="color: black;" density="compact">
            <thead><tr><th>Medicine</th><th>Quantity</th><th>Price</th></tr></thead>
            <tbody>
                <tr v-for="item in prescriptions" :key="item.id">
                <td>{{ item.medicine.name }} </td>
                <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                <td>{{ item.totalprice }}</td>
                </tr>
            </tbody>
            </table>
        </span>
        <span v-if="consumables.length">
        <h5 >Consumables</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
          <tbody>
              <tr v-for="item in consumables" :key="item.id">
              <td>{{ item.consumbale.name }} </td>
              <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              <td>{{ item.totalprice }}</td>
              </tr>
          </tbody>
          </table>
        </span>
      <span v-if="payments.length">
    <h5 >Payments</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Payment Type</th></tr></thead>
      <tbody>
        <tr v-for="item in payments" :key="item.id">
            <td>{{ item.pay_date }}</td>
            <td>{{ commas(item.amount_paid) }}</td>
            <td>
              <span v-if="item.payment_type==1">Cash</span>
              <span v-else>Account</span>
            </td>
        </tr>
      </tbody>
      </table>
      </span>

      <div class="mt-2 text-center">
        <span style="color: black;font-size:14px"><b> AMOUNT PAID : {{commas(amount_paid)}}</b></span><br>
        <span style="color: black;font-size:14px"><b> PENDING BALANCE : {{commas(balance)}}</b></span><br>
        <p style="color:black;font-size:13px">Printed by : {{ userData.username }}
        <br> On : {{ new Date().toLocaleString() }}
        <br>Thanks for Supporting Us. <br> Printed Via Afrimed Software
        <br> www.afrimedsolutions.com </p>
    </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      payments:[],
      services:[],
      patientid:'',
      visitid:'',
      consumables:[],
      prescriptions:[],
      amount_paid:0,
      balance:0,
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/legderinfo/${this.id}`;
      await axios.get(url).then((response) => {
        this.patientid = response.data.visits[0].patient.patient_id;
        this.visitid = response.data.visits[0].visit_id;
        this.showpatient();
        
      });
    },
    async showpatient(){
      let url = `/patientprofile/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
        this.showpayments();
        this.showservices();
        this.showtprescriptions();
        this.showtconsumables();
        this.showbalances();

      });
    },
    async showservices(){
      let url = `/profileservices/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.services = response.data.visits;
      });
    },
    async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtconsumables(){
        let url = `/profileconsumables/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consumables = response.data.consumables;
        });
      },
    async showpayments(){
      let url = `/legdgerpayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.payments;
      });
    },
    async showbalances(){
      let url = `/invoicepayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.amount_paid = response.data.payments[0].paid;
        this.balance = response.data.payments[0].balance;

        setTimeout(() => { window.print(); window.onafterprint=this.$router.go(-1); }, 2000);
      });
    },
  },
  };
</script>